module.exports = __webpack_public_path__ + "static/media/CTLA_8-383w.a56fc762.webp";